import type { DeviceChangeActivity } from "src/types"
import { DeviceType } from "src/types"

export const defaultDeviceChangeActivity: DeviceChangeActivity = {
  device_type: DeviceType.NotProvided,
}
